import type { LeaveAllocationPersonRow } from "@/features/leave/components/leave-allocation-people-table.columns";

export const ALLOCATION_HEALTH_FILTERS = ["all", "ready", "needs_allocation", "no_plan"] as const;

export type AllocationHealthFilter = (typeof ALLOCATION_HEALTH_FILTERS)[number];

export function filterLeaveAllocationPeople(
  rows: ReadonlyArray<LeaveAllocationPersonRow>,
  filter: AllocationHealthFilter,
): ReadonlyArray<LeaveAllocationPersonRow> {
  if (filter === "all") return rows;

  const status = filter === "needs_allocation" ? "pending" : filter;
  return rows.filter((row) => row.allocationStatus === status);
}

export function allocationHealthFilterDescription(filter: AllocationHealthFilter): string {
  if (filter === "ready") return "Showing people whose plan allocations are ready.";
  if (filter === "needs_allocation") return "Showing people who need a plan allocation.";
  if (filter === "no_plan") return "Showing people with no leave plan.";
  return "Start with a person, then inspect the plans and allocations behind their entitlement.";
}
